import { createAsyncThunk } from "@reduxjs/toolkit"
import { get, patch, post } from "helpers/api_helper"
import {
  CHANGE_PASSWORD,
  FORGOT_PASSWORD,
  GET_PROFILE_DETAILS,
  LOGIN_URL,
  OTP_VERIFICATION,
} from "helpers/url_helper"

export const login = createAsyncThunk(LOGIN_URL, async payload => {
  const response = await post(LOGIN_URL, payload)
  return response
})

export const forgotPassword = createAsyncThunk(
  FORGOT_PASSWORD,
  async payload => {
    const response = await post(FORGOT_PASSWORD, payload)
    return response
  }
)

export const otpVerification = createAsyncThunk(
  OTP_VERIFICATION,
  async payload => {
    const response = await post(OTP_VERIFICATION, payload)
    return response
  }
)

export const changePassword = createAsyncThunk(
  CHANGE_PASSWORD,
  async payload => {
    const response = await post(CHANGE_PASSWORD, payload)
    return response
  }
)

export const getProfileDetails = createAsyncThunk(
  GET_PROFILE_DETAILS,
  async uuid => {
    const response = await get(`${GET_PROFILE_DETAILS}/${uuid}`)
    return response
  }
)
